import axios, { AxiosError, AxiosInstance } from 'axios'
import { message } from 'antd'
import type { ApiError } from '@/types/api'

const BASE_URL = '/api/v1' // 走 Vite proxy
const API_KEY = import.meta.env.VITE_API_KEY || 'demo-api-key'

export const api: AxiosInstance = axios.create({
  baseURL: BASE_URL,
  timeout: 30_000,
  headers: {
    'X-API-Key': API_KEY,
  },
})

// 响应拦截：把后端 {error: {...}} 统一抛出
api.interceptors.response.use(
  (r) => r,
  (err: AxiosError<{ error?: ApiError }>) => {
    const apiError = err.response?.data?.error
    if (apiError) {
      const msg = `${apiError.code}: ${apiError.message}`
      message.error(msg, 4)
      return Promise.reject(Object.assign(new Error(msg), { apiError }))
    }
    const fallback = err.message || '请求失败'
    message.error(fallback, 4)
    return Promise.reject(err)
  },
)

// 拼接下载 URL 时用（带 API Key query 参数以支持 <a> 直接下载）
export function withAuth(url: string): string {
  const sep = url.includes('?') ? '&' : '?'
  return `${url}${sep}api_key=${encodeURIComponent(API_KEY)}`
}

// 直接 fetch 二进制（下载）
export async function downloadFile(url: string, filename: string): Promise<void> {
  const res = await api.get(url, { responseType: 'blob' })
  const blob = new Blob([res.data])
  const objectUrl = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = objectUrl
  a.download = filename
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  URL.revokeObjectURL(objectUrl)
}
